import { useState } from 'react'
import { useMemorama } from '../../context/MemoramaContext'
import { useLanguage } from '@context/LanguageContext'
import { useDeviceType } from '@hooks/useDeviceType'
import BoardSizeSelector from '../ui/BoardSizeSelector'
import { PlayerForm, PlayerList, getAvatarName, MAX_PLAYERS, handleAddPlayer, handleAvatarSelect } from '@shared'
import StartGameButton from '../ui/StartGameButton'
import styles from './MemoramaStart.module.css'

function MemoramaStart () {
  const [playerName, setPlayerName] = useState('')
  const [error, setError] = useState('')
  const [selectingAvatarFor, setSelectingAvatarFor] = useState(null)

  const { t } = useLanguage()

  const {
    players,
    addPlayer,
    removePlayer,
    setPlayers
  } = useMemorama()

  // Device type detection
  const { isTabletVertical, isTabletHorizontalOrDesktop } = useDeviceType()

  const isMaxPlayers = players.length >= MAX_PLAYERS

  const onAddPlayer = () => {
    handleAddPlayer({
      playerName,
      players,
      addPlayer,
      setPlayerName,
      setError,
      t
    })
  }

  const onAvatarChange = (playerId, filename) => {
    handleAvatarSelect({
      playerId,
      filename,
      players,
      setPlayers,
      setSelectingAvatarFor
    })
  }

  const handleDeletePlayer = (id) => {
    removePlayer(id)
  }

  const canStartGame = players.length > 0

  return (
    <div className={styles.startScreen}>
      <div className={styles.content}>
        {(isTabletVertical || isTabletHorizontalOrDesktop) && <BoardSizeSelector />}

        <PlayerForm
          playerName={playerName}
          setPlayerName={setPlayerName}
          onAddPlayer={onAddPlayer}
          isDisabled={isMaxPlayers}
          error={error}
        />
        <PlayerList
          players={players}
          selectingAvatarFor={selectingAvatarFor}
          setSelectingAvatarFor={setSelectingAvatarFor}
          onAvatarChange={onAvatarChange}
          onDeletePlayer={handleDeletePlayer}
          getAvatarName={getAvatarName}
        />
      </div>

      <div className={styles.actions}>
        <StartGameButton
          setSelectingAvatarFor={setSelectingAvatarFor}
          isDisabled={!canStartGame}
        />
      </div>
    </div>
  )
}
export default MemoramaStart
